import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _shuffle from "lodash/shuffle";
import _map from "lodash/map";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import createQueryHook from '@segment/utils/createQueryHook';
import { createFsCacheProxy } from '@segment/utils/fsCache';
import createInfiniteQueryHook from '@segment/utils/createInfinityQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
export var MAX_RECOMMENDED = 9;
export var DEFAULT_LIMIT = 6;
export var DEFAULT_OFFSET = 0;
/**
 * Helper function that returns all recommended lessons comparing
 * all categories of all lessons.
 * @param lesson LessonResponse
 * @param lessons LessonResponse[]
 * @returns Lesson[]
 */

var listRecommendedLessons = function listRecommendedLessons(lesson, lessons) {
  var recommended = [];
  var badges = lesson.badges;

  var _iterator = _createForOfIteratorHelper(lessons),
      _step;

  try {
    var _loop = function _loop() {
      var single = _step.value;

      // Remove itself from the search.
      if (lesson.title !== single.title) {
        badges.every(function (rec) {
          var has = single.badges.filter(function (l) {
            return l === rec;
          }); // If category found, add to array just once and breaks the loop.

          if (has.length > 0) {
            recommended.push(single);
            return false;
          }

          return true;
        });
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return _shuffle(recommended).slice(0, MAX_RECOMMENDED);
};
/**
 * Helper function that returns all recommended lessons comparing
 * all categories of all lessons.
 * @param lesson LessonResponse
 * @returns Bio
 */


var formatLesson = function formatLesson(lesson) {
  var _author$fields$headsh, _lesson$resources;

  var author = lesson.speakers[0];
  var speaker = {
    type: author.fields.type,
    name: author.fields.name,
    title: author.fields.title,
    headshotUrl: ((_author$fields$headsh = author.fields.headshot) === null || _author$fields$headsh === void 0 ? void 0 : _author$fields$headsh.fields.file.url) || "",
    company: author.fields.company,
    description: author.fields.description,
    linkedInUrl: author.fields.linkedInUrl
  };
  return {
    title: lesson.title,
    slug: lesson.slug,
    videoUrl: lesson.videoUrl,
    badges: lesson.lessonTopics.map(function (topic) {
      return topic.fields.title;
    }),
    videoCoverUrl: lesson.videoThumbnail.fields.file.url,
    speaker: speaker,
    shortDescription: lesson.shortDescription,
    resources: ((_lesson$resources = lesson.resources) === null || _lesson$resources === void 0 ? void 0 : _lesson$resources.map(function (res) {
      return res.fields;
    })) || [],
    featured: lesson.featured || false
  };
};
/**
 * Helper that returns cached array size from speakers/lessons
 * @param client Client
 * @param filters FiltersState
 * @returns lesson's array size
 */


var lessonsArraySize = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, filters) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchLessons(client, {
              filters: filters
            });

          case 2:
            data = _context.sent;
            return _context.abrupt("return", data.length);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function lessonsArraySize(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export var fetchLessons = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
    var options,
        enabled,
        searchParams,
        pagination,
        filters,
        _pagination$offset,
        offset,
        _pagination$limit,
        limit,
        cachedFetch,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            searchParams = new URLSearchParams();
            pagination = options.pagination, filters = options.filters;

            if (pagination) {
              _pagination$offset = pagination.offset, offset = _pagination$offset === void 0 ? DEFAULT_OFFSET : _pagination$offset, _pagination$limit = pagination.limit, limit = _pagination$limit === void 0 ? DEFAULT_LIMIT : _pagination$limit;
              searchParams.set("limit", limit.toString());
              searchParams.set("offset", offset.toString());
            }

            if (filters) {
              _map(filters, function (value, key) {
                var filterParams = value.map(function (item) {
                  return item.value;
                });
                searchParams.set("fields.".concat(key, ".sys.id").concat(filterParams.length > 1 ? "[in]" : ""), filterParams.toString());
              });
            }

            _context3.next = 8;
            return createFsCacheProxy(["growthMaster/lessonsQuery"], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var formatted;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return client.get("/content/entries/growthMastersLesson/?".concat(searchParams.toString()));

                    case 2:
                      formatted = _context2.sent;
                      return _context2.abrupt("return", formatted.map(function (lesson) {
                        return formatLesson(lesson);
                      }));

                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })), {
              enabled: enabled
            });

          case 8:
            cachedFetch = _context3.sent;
            return _context3.abrupt("return", cachedFetch());

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchLessons(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchLessonsSlugs = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(client) {
    var allLessons;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetchLessons(client);

          case 2:
            allLessons = _context4.sent;
            return _context4.abrupt("return", allLessons === null || allLessons === void 0 ? void 0 : allLessons.map(function (lesson) {
              return {
                slug: lesson === null || lesson === void 0 ? void 0 : lesson.slug
              };
            }));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchLessonsSlugs(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var fetchSpeakerLessons = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(client, pagination) {
    var allLessons;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetchLessons(client, {
              pagination: pagination
            });

          case 2:
            allLessons = _context5.sent;
            return _context5.abrupt("return", allLessons === null || allLessons === void 0 ? void 0 : allLessons.map(function (lesson) {
              return {
                speaker: lesson.speaker,
                lessonLink: lesson.slug
              };
            }));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchSpeakerLessons(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();
export var lessonQuery = function lessonQuery(client, slug) {
  return [["growthMaster/lessonQuery", slug], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var allLessons, lesson;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetchLessons(client);

          case 3:
            allLessons = _context6.sent;
            lesson = allLessons.find(function (s) {
              return s.slug === slug;
            });

            if (lesson) {
              _context6.next = 7;
              break;
            }

            throw new Error("Lesson data is empty");

          case 7:
            return _context6.abrupt("return", _objectSpread(_objectSpread({}, lesson), {}, {
              recommended: listRecommendedLessons(lesson, allLessons)
            }));

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to find lesson with ".concat(slug, "."));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }))];
};
export var useLessonQuery = createQueryHook(lessonQuery, useStaticSiteBackend, {
  staleTime: Infinity
});
export var createLessonsQuery = function createLessonsQuery(client, limit) {
  return [["growthMaster", "growthMasterLandingSpeakers", limit !== null && limit !== void 0 ? limit : null], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var lessons;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return fetchLessons(client);

          case 2:
            lessons = _context7.sent;
            return _context7.abrupt("return", lessons.filter(function (l) {
              return l.featured;
            }).slice(0, limit));

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }))];
};
export var useLessonsQuery = createQueryHook(createLessonsQuery, useStaticSiteBackend, {
  staleTime: Infinity
});
export var createFetchSpeakersQuery = function createFetchSpeakersQuery(client, limit) {
  return [["growthMaster", "growthMasterSpeakers", limit !== null && limit !== void 0 ? limit : null], /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref8) {
      var _ref8$pageParam, pagination, lessons;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _ref8$pageParam = _ref8.pageParam, pagination = _ref8$pageParam === void 0 ? {} : _ref8$pageParam;
              _context8.next = 3;
              return fetchSpeakerLessons(client, pagination);

            case 3:
              lessons = _context8.sent;
              _context8.next = 6;
              return lessonsArraySize(client);

            case 6:
              _context8.t0 = _context8.sent;
              _context8.t1 = pagination.offset || 0;
              _context8.t2 = limit;
              _context8.t3 = lessons;
              return _context8.abrupt("return", {
                total: _context8.t0,
                skip: _context8.t1,
                limit: _context8.t2,
                items: _context8.t3
              });

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x7) {
      return _ref9.apply(this, arguments);
    };
  }()];
};
export var useSpeakersQuery = createInfiniteQueryHook(createFetchSpeakersQuery, useStaticSiteBackend, {
  staleTime: Infinity,
  getNextPageParam: function getNextPageParam(p) {
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});
export var createCurriculumQuery = function createCurriculumQuery(client, filters) {
  return [["growthMaster", "growthMasterCurriculum", filters !== null && filters !== void 0 ? filters : null], /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref10) {
      var _ref10$pageParam, pagination, lessons;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _ref10$pageParam = _ref10.pageParam, pagination = _ref10$pageParam === void 0 ? {} : _ref10$pageParam;
              _context9.next = 3;
              return fetchLessons(client, {
                pagination: pagination,
                filters: filters
              });

            case 3:
              lessons = _context9.sent;
              _context9.next = 6;
              return lessonsArraySize(client, filters);

            case 6:
              _context9.t0 = _context9.sent;
              _context9.t1 = pagination.offset || 0;
              _context9.t2 = DEFAULT_LIMIT;
              _context9.t3 = lessons;
              return _context9.abrupt("return", {
                total: _context9.t0,
                skip: _context9.t1,
                limit: _context9.t2,
                items: _context9.t3
              });

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x8) {
      return _ref11.apply(this, arguments);
    };
  }()];
};
export var useCurriculumQuery = createInfiniteQueryHook(createCurriculumQuery, useStaticSiteBackend, {
  staleTime: Infinity,
  getNextPageParam: function getNextPageParam(p) {
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});